module.exports = __webpack_public_path__ + "img/LOGO-OUB-WHITE.4f077d40.svg";